
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'


export default {
name: 'batch_record_detail',
components: {
CheckIcon,
PopupRadio,
Checklist,
CellBox,
},
data() {
return {
isBaby: false,
buttonTabVal: 0,
start_date: '',
end_date: '',
page: 1,
use_table: 0,
min_date: '',
memberList: [],
data_list: [],
detail: null,
warn: 0,
normal: 0,
}
},
methods: {
formatDateTime(inputTime) {
var date = new Date(parseInt(inputTime) * 1000)
var y = date.getFullYear()
var m = date.getMonth() + 1
m = m < 10 ? '0' + m : m
var d = date.getDate()
d = d < 10 ? '0' + d : d
var h = date.getHours()
h = h < 10 ? '0' + h : h
var minute = date.getMinutes()
var second = date.getSeconds()
minute = minute < 10 ? '0' + minute : minute
second = second < 10 ? '0' + second : second
return y + '-' + m + '-' + d
},
goBack() {
this.$router.push({
path: './batch_record',
})
},
change(val, label) {},
apiRecordList() {
this.$vux.loading.show({
text: '正在加载',
})
let that = this
let params = {
token: this.$cookie.get('token'),
id: this.$route.query.id,
}
console.log('params', params)
Api.memberListApi.batchHeathRecordDetail(params).then((res) => {
console.log('batchHeathRecordDetail', res)
if (res.errcode == 1) {
this.memberList = res.data.list
this.detail = res.data.base
if (
this.detail.use_table == 3 ||
this.detail.use_table == 4 ||
this.detail.use_table == 1
) {
this.isBaby = true
}
this.memberList.sort((a, b) => {
return parseInt(a.state) < parseInt(b.state)
})
this.memberList.forEach((item) => {
let _desc =
'电话：' +
item.phone +
' 时间：' +
this.formatDateTime(item.live_time) +
' 套餐：' +
item.package_name +
' 房号：' +
item.room
if (item.state == 2) {
this.warn++
}
if (item.state == 1) {
this.normal++
item.isSelect = true
}else{
item.isSelect = false
}
item.key = item.id
item.value = item.name
item.inlineDesc = _desc
})
} else {
this.$vux.toast.show({
type: 'cancel',
text: res.errinfo,
})
}
this.$vux.loading.hide()
})
},
start_date_congirm(value) {
this.formListDetailListPage = 1
this.formListDetailList = []
this.min_date = value
this.start_date = value
console.info('选择开始日期')
this.forFormIDUseMethod()
},

end_date_congirm(value) {
this.formListDetailListPage = 1
this.formListDetailList = []
this.end_date = value
console.info('选择结束日期')
this.forFormIDUseMethod()
},
forFormIDUseMethod() {},
},
created() {
this.apiRecordList()
},
}



// WEBPACK FOOTER //
// ./src/components/batch_record_detail.vue